import PropTypes from 'prop-types';

function IconStream({
  fill = 'var(--primaryColor)',
  backgroundFill = 'var(--secondaryColor)',
}) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9998 7.80007V12.1001H0.799805V3.70007H16.3998V6.60007H15.1998C14.5378 6.60007 13.9998 7.13807 13.9998 7.80007Z"
        fill={backgroundFill}
      />
      <path
        d="M19.1998 8.99994H14.7998V14.6999H19.1998V8.99994Z"
        fill={backgroundFill}
      />
      <path
        d="M18.8 6.60005H17.2V3.30005C17.2 3.08005 17.02 2.90005 16.8 2.90005H0.4C0.18 2.90005 0 3.08005 0 3.30005V14.1001C0 14.3201 0.18 14.5001 0.4 14.5001H8.2V16.3001H6.4C6.18 16.3001 6 16.4801 6 16.7001C6 16.9201 6.18 17.1001 6.4 17.1001H8.2H9H10.8C11.02 17.1001 11.2 16.9201 11.2 16.7001C11.2 16.4801 11.02 16.3001 10.8 16.3001H9V14.5001H14V15.9001C14 16.5621 14.538 17.1001 15.2 17.1001H18.8C19.462 17.1001 20 16.5621 20 15.9001V7.80005C20 7.13805 19.462 6.60005 18.8 6.60005ZM14 13.7001H0.8V12.9001H14V13.7001ZM14 7.80005V12.1001H0.8V3.70005H16.4V6.60005H15.2C14.538 6.60005 14 7.13805 14 7.80005ZM19.2 15.9001C19.2 16.1201 19.02 16.3001 18.8 16.3001H15.2C14.98 16.3001 14.8 16.1201 14.8 15.9001V15.5001H19.2V15.9001ZM19.2 14.7001H14.8V9.00005H19.2V14.7001ZM19.2 8.20005H14.8V7.80005C14.8 7.58005 14.98 7.40005 15.2 7.40005H18.8C19.02 7.40005 19.2 7.58005 19.2 7.80005V8.20005Z"
        fill={fill}
      />
      <path
        d="M16.4002 12.7259C16.4302 12.7259 16.4602 12.7199 16.4902 12.7039L17.8422 12.0279C17.9902 11.9539 17.9902 11.7439 17.8422 11.6699L16.4902 10.9939C16.4602 10.9799 16.4302 10.9719 16.4002 10.9719C16.2962 10.9719 16.2002 11.0559 16.2002 11.1719V12.5239C16.2002 12.6419 16.2962 12.7259 16.4002 12.7259Z"
        fill={fill}
      />
      <path
        d="M10.8842 7.74206L7.7782 6.19006C7.7462 6.17406 7.7142 6.16406 7.6822 6.15606C7.6722 6.15406 7.6602 6.15406 7.6502 6.15206C7.6322 6.15006 7.6162 6.14606 7.6002 6.14606C7.5962 6.14606 7.5902 6.14806 7.5862 6.14806C7.5762 6.14806 7.5682 6.15006 7.5582 6.15006C7.5362 6.15206 7.5162 6.15606 7.4962 6.16206C7.4862 6.16406 7.4782 6.16806 7.4682 6.17006C7.4462 6.17806 7.4262 6.18806 7.4062 6.19806C7.4002 6.20206 7.3942 6.20406 7.3882 6.20806C7.3622 6.22406 7.3402 6.24206 7.3182 6.26406C7.3122 6.27006 7.3082 6.27606 7.3042 6.28006C7.2882 6.29606 7.2742 6.31406 7.2622 6.33406C7.2562 6.34206 7.2522 6.35206 7.2482 6.36006C7.2382 6.38006 7.2302 6.40006 7.2222 6.42006C7.2182 6.43006 7.2162 6.43806 7.2142 6.44806C7.2062 6.48206 7.2002 6.51406 7.2002 6.54806V9.65406C7.2002 9.68806 7.2062 9.72006 7.2122 9.75006C7.2142 9.76006 7.2182 9.76806 7.2202 9.77806C7.2262 9.80006 7.2362 9.82006 7.2462 9.83806C7.2502 9.84606 7.2562 9.85606 7.2602 9.86406C7.2722 9.88406 7.28619 9.90206 7.30219 9.91806C7.30619 9.92406 7.3102 9.93006 7.3162 9.93406C7.3382 9.95606 7.3602 9.97406 7.3862 9.99006C7.3922 9.99406 7.3982 9.99606 7.4042 10.0001C7.4242 10.0121 7.4462 10.0221 7.4682 10.0301C7.4782 10.0341 7.4862 10.0361 7.4962 10.0381C7.5162 10.0441 7.5382 10.0481 7.5582 10.0501C7.5682 10.0521 7.5762 10.0521 7.5862 10.0521C7.5902 10.0521 7.5962 10.0541 7.6002 10.0541C7.6162 10.0541 7.6342 10.0501 7.6502 10.0481C7.6602 10.0461 7.6722 10.0461 7.6822 10.0441C7.7142 10.0381 7.7462 10.0261 7.7782 10.0101L10.8842 8.45806C10.9942 8.40206 11.0642 8.31006 11.0922 8.20606C11.1382 8.03406 11.0682 7.83406 10.8842 7.74206Z"
        fill={fill}
      />
    </svg>
  );
}

IconStream.propTypes = {
  fill: PropTypes.string,
  backgroundFill: PropTypes.string,
};

export default IconStream;
